import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { ArrowRight } from 'lucide-react';
const services = [{
  title: 'Construction Milestone Documentation',
  description: 'Create visual records of construction progress, allowing developers and stakeholders to revisit project milestones remotely.',
  image: 'https://cdn.magicpatterns.com/patterns/generated-images/94377bd1-a841-4fb9-976d-59549160ea2c.jpg'
}, {
  title: 'Completed Property Virtual Tours',
  description: 'Help buyers, tenants and investors explore completed properties through immersive 360° experiences before physical inspections.',
  image: 'https://images.unsplash.com/photo-1618221195710-dd6b41faaea6?q=80&w=2070&auto=format&fit=crop'
}, {
  title: 'One-Off Valuation Scans',
  description: 'Enhance valuation reports with immersive visual records of properties and their condition.',
  image: 'https://cdn.magicpatterns.com/patterns/generated-images/e69c1e0f-6e9e-48da-b1f2-963ce81101f5.jpg'
}, {
  title: 'Property Documentation',
  description: 'Create accessible digital records of property condition, inspections, handovers and other property-related events.',
  image: 'https://images.unsplash.com/photo-1582407947304-fd86f028f716?q=80&w=2096&auto=format&fit=crop'
}, {
  title: 'Virtual Staging',
  description: "Help prospective buyers visualise a property's potential through digitally furnished spaces.",
  image: 'https://images.unsplash.com/photo-1512917774080-9991f1c4c750?q=80&w=2070&auto=format&fit=crop'
}, {
  title: '3D Development Visualisation',
  description: 'Transform development plans into immersive visualisations that help people understand proposed projects before construction.',
  image: 'https://cdn.magicpatterns.com/patterns/generated-images/2c84e6a4-777d-4703-89a1-9b400217697c.jpg'
}];
export function Services() {
  return <section id="services" className="py-32 bg-zinc-950" data-id="element-156" data-mp="29juh9r2mxpr6">
      <div className="max-w-7xl mx-auto px-6" data-id="element-157" data-mp="1piswsdh1szk2">
        <FadeIn className="mb-20" data-id="element-158" data-mp="1lihakw91er6h">
          <h2 className="text-4xl md:text-5xl font-display font-medium text-white mb-6" data-id="element-159" data-mp="1ljk0p1yjcplc">
            Our Services. <br data-id="element-160" data-mp="1gqqyolugbvcy" />
            One immersive ecosystem.
          </h2>
        </FadeIn>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8" data-id="element-161" data-mp="1bth9n7az5lpn">
          {services.map((service, index) => <FadeIn key={index} delay={index * 0.1} className="group cursor-pointer" data-id="element-162" data-mp="16unz9nqziatp" data-mpi={index}>
              <div className="relative aspect-[4/5] rounded-3xl overflow-hidden mb-6" data-id="element-163" data-mp="11wur4p64f6qs">
                <img src={service.image} alt={service.title} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" data-id="element-164" data-mp="xv0t6onb8gub" />
                <div className="absolute inset-0 bg-gradient-to-t from-zinc-950 via-zinc-950/20 to-transparent opacity-80" data-id="element-165" data-mp="2n7usfxqvfayt" />

                <div className="absolute bottom-0 left-0 right-0 p-8" data-id="element-166" data-mp="2us5g04bowc9t">
                  <h3 className="text-2xl font-display font-medium text-white mb-3" data-id="element-167" data-mp="2zqgn47alo8oc">
                    {service.title}
                  </h3>
                  <p className="text-zinc-400 text-sm leading-relaxed mb-6 line-clamp-3" data-id="element-168" data-mp="34ihx1mkapnb7">
                    {service.description}
                  </p>
                  <div className="flex items-center text-white text-sm font-medium group-hover:gap-3 transition-all" data-id="element-169" data-mp="2bshu3t9cukaz">
                    Learn more <ArrowRight size={16} className="ml-2" data-id="element-170" data-mp="2gsnmxcrd2cun" />
                  </div>
                </div>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}